import React, { useContext } from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import { StaticImage, GatsbyImage, getImage } from "gatsby-plugin-image";

import { FlexWrap } from "../Section";
import PrimaryLinkButton from "../Button/PrimaryLinkButton";
import SecondButton from "../Button/SecondButton";
import LineArrowRight from "../Icons/LineArrowRight";
import PhoneIcon from "../Icons/PhoneIcon";
import WidthIcon from "../Icons/WidthIcon";
import HeightIcon from "../Icons/HeightIcon";
import LengthIcon from "../Icons/LengthIcon";

import { Context } from "../../layouts/context";

const CardWrap = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 30px 28px 30px 0;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.1);
  align-items: center;
  margin-bottom: 30px;

  .image-wrap {
    width: 50%;
  }
  .text-wrap {
    margin-top: -10px;
    width: 45%;

    h3 {
      margin-bottom: 25px;
    }
    label {
      color: #938888;
    }
    .start-price {
      font-size: 26px;
      line-height: 30px;
      margin: 0;
      margin-bottom: 20px;
    }
    .down-price {
      font-size: 32px;
      line-height: 40px;
      color: #e43d3c;
    }
    .feature {
      padding: 5px 25px 6px;
      margin-bottom: 20px;
      text-align: center;
      min-width: 142px;
      font-size: 14px;
      line-height: 1;
      color: #574c4c;
      border: 1px solid #d0d0d0;
      border-radius: 30px;
    }
    .btn {
      margin-top: 20px;
    }

    .btn-second {
      font-size: 26px;
    }
    .btn-primary {
      font-size: 20px;
    }
    .description {
      font-size: 14px;
      line-height: 19px;
      margin: 27px 0 0;
    }
  }
  @media (max-width: 1200px) {
    flex-wrap: wrap;
    max-width: 600px;
    margin: 0px auto 50px;
    padding: 20px;

    .image-wrap {
      width: 100%;
      margin-bottom: 30px;
    }
    .text-wrap {
      margin-top: 20px;
      width: 100%;
      margin-bottom: 30px;
    }
  }
  @media (max-width: 480px) {
    padding: 20px 10px;
    .text-wrap {
      .start-price {
        font-size: 22px;
      }
      .down-price {
        font-size: 22px;
      }
      .btn {
        margin-top: 10px;
      }
      .btn-second {
        font-size: 16px;
        padding: 8px 10px;
      }
      .btn-primary {
        font-size: 16px;
        padding: 8px 10px;
      }
    }
  }
`;

const SkuWrap = styled.div`
  position: absolute;
  z-index: 2;
  top: 10px;
  left: -22px;
  width: 180px;

  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
  }
  .sku {
    position: absolute;
    top: 8px;
    left: 30px;
    width: 150px;
    font-size: 14px;
    line-height: 19px;
    color: white;
    text-transform: uppercase;
  }
`;
const DimensionsWrap = styled.div`
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  padding: 5px 20px 15px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  margin: auto;
  margin-top: -30px;
  width: fit-content;

  .dimension {
    display: flex;
    align-items: center;
    margin-left: 15px;
    margin-right: 15px;

    label {
      font-size: 10px;
      line-height: 14px;
      color: #656565;
    }
    h5,
    .h5 {
      display: block;
      font-size: 15px;
      line-height: 1;
      margin: 0;
    }
    svg {
      margin-right: 3px;
      margin-bottom: -15px;
    }
  }
  @media (max-width: 480px) {
    margin-top: -30px;
    padding: 5px 10px 15px;
  }
  @media (max-width: 380px) {
    margin-top: -30px;
    padding: 5px 5px 15px;
    .dimension {
      margin-left: 5px;
      margin-right: 5px;
    }
  }
`;

const CallPrice = styled.a`
  font-size: 24px;
  color: #000000;

  :hover {
    cursor: pointer;
    text-decoration: underline;
    color: #e43d3c;
  }
`;
const ProductCard = ({ data }) => {
  const { setPopupContext } = useContext(Context);
  return (
    <CardWrap>
      <SkuWrap>
        <StaticImage
          src="../../images/sku.png"
          placeholder="blurred"
          formats={["AUTO", "WEBP", "AVIF"]}
          alt="sku"
        />
        <div className="sku">sku: {data.sku}</div>
      </SkuWrap>
      <Link to={data.url} className="image-wrap">
        <GatsbyImage
          image={getImage(data.image.gatsbyImageData)}
          alt={data.name}
        />
        <DimensionsWrap>
          <div className="dimension">
            <div>
              <WidthIcon />
            </div>
            <div>
              <label htmlFor="width">Width</label>
              <strong className="h5">{data.width}</strong>
            </div>
          </div>
          <div className="dimension">
            <div>
              <LengthIcon />
            </div>
            <div>
              <label htmlFor="length">Length</label>
              <strong className="h5">{data.length}</strong>
            </div>
          </div>
          {data.category?.name !== "Gazebos" &&
            data.subCategory?.name !== "Metal Barns" && (
              <div className="dimension">
                <div>
                  <HeightIcon />
                </div>
                <div>
                  <label htmlFor="height">Height</label>
                  <strong className="h5">{data.height}</strong>
                </div>
              </div>
            )}
        </DimensionsWrap>
      </Link>
      <div className="text-wrap">
        <Link to={data.url}>
          <h3>{data.name}</h3>
        </Link>
        <CallPrice href="tel:3867556449">Call for Pricing</CallPrice>
        <FlexWrap alignItems="center">
          <a href="tel:3867556449">
            <SecondButton
              text="(386) 755-6449"
              icon={<PhoneIcon fill="#ffffff" />}
            />
          </a>
          <div onClick={() => setPopupContext("block")} aria-hidden="true">
            <PrimaryLinkButton text="Get a quote" icon={<LineArrowRight />} />
          </div>
        </FlexWrap>
        <p className="description">
          * Price may vary with states and certification requirement
        </p>
      </div>
    </CardWrap>
  );
};

export default ProductCard;
